// removed by extract-text-webpack-plugin
module.exports = {"reviews":"reviews__3I-nQ","review-list":"review-list__3m-kz","loading-item":"loading-item__2cVGx","reviews-wrapper":"reviews-wrapper__277lz"};


//////////////////
// WEBPACK FOOTER
// ./app/scripts/views/App/components/Reviews/styles.scss
// module id = ./app/scripts/views/App/components/Reviews/styles.scss
// module chunks = 1